<template>
    <modal name="project-delete-confirmation-modal" :pivotY="0.2" width="590" height="auto">
        <div class="modal-img-container">
            <img class="modal-img" :src="titleImageProject(projectGUID)"/>
        </div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" v-on:click="hideModal('project-delete-confirmation-modal')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="modal-title">
            Удалить проект
        </div>
        <div class="modal-text">
            Удалить проект<span class="bold-text"> {{nameProject}}</span>?
        </div>
        <div class="modal-button" @click="deleteProject">
            Удалить
        </div>
    </modal>
</template>

<script>
    import {modalMethods, urlForFileStorage, urlForStaticVue} from "../common";
    import SVGModalClose from "../SVG/SVGModalClose.vue";

    export default {
        name: "ModalDeleteProject",
        components: {SVGModalClose},
        mixins: [urlForStaticVue, urlForFileStorage, modalMethods],
        computed: {
            nameProject(){
                return this.$store.getters['active/NAME'];
            },
            projectGUID() {
                return this.$store.state.route.params.projectUUID
            }
        },
        methods: {
            deleteProject:async function () {
                this.hideModal('project-delete-confirmation-modal');
                const uuidDeletedProject = await this.$store.dispatch('projectList/DELETE_ACTIVE_PROJECT');
                if(uuidDeletedProject) {
                    this.$store.commit('UI/loadedProjectList/DELETE_PROJECT_BY_UUID', uuidDeletedProject);
                } else {
                    console.error('Проект не удалился!');
                }
            },
            titleImageProject(projectGUID) {
                const src = this.$store.getters[`projectList/${projectGUID}/photoList/SRC_FIRST_PHOTO`];
                if (src) {
                    return this.urlForFileStorage(src);
                } else {
                    return this.urlForStatic('img/No_Picture.jpg');
                }
            }
        }
    }
</script>

<style scoped>

</style>
